<template>
  <div class="row" style="margin-bottom: 10px; margin-top: 30px">
    <div class="col-md-12 text-center">
      <HomeVencimento
        ref="homeVencimento"
        :planoAtivo="planoAtivo"
        :planoDias="planoDias"
        :vencimento="vencimento"
        @recarregar="recarregarMeusDados()"
      />

      <div class="row" style="margin-bottom: 50px; display: none">
        <div class="col-md-12 text-center">Mensagem</div>
      </div>

      <div class="row justify-content-md-center">
        <div class="col-12 col-sm-12 col-md-8 text-center">
          <ListEventosHome
            ref="listEventosHomeLive"
            :itens="itens"
            :filtroSituacao="[3]"
            :icone="true"
            :planoAtivo="planoAtivo"
            :itensUsuario="itensUsuario"
            @recarregar="carregarItens()"
          />

          <div class="row justify-content-md-center" style="margin-top: 20px">
            <div class="col-md-8 col-sm-12 text-center">
              <div class="text-center">
                <h2 class="tituloJogos">Finalizados</h2>
              </div>
              <ListEventosHome
                ref="listEventosHomeEncerrados"
                :itens="itens"
                :filtroSituacao="[4]"
                :icone="true"
                :ordemReversa="true"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { api } from "@/services/api.js";
import util from "../includes/util.js";

import ListEventosHome from "../lists/ListEventosHome4";
import HomeVencimento from "../features/HomeVencimento";

export default {
  name: "HomeAoVivo",
  components: { ListEventosHome, HomeVencimento },
  methods: {
    retornaSite() {
      return this.$site;
    },
    retornaTipoUsuario() {
      return this.$sessao ? this.$sessao.usuario.tipoUsuario : "";
    },
    formatDate(data) {
      if (data == "-") {
        return data;
      }
      return util.formatDate(data);
    },
    async carregarItens() {
      var componentThis = this;

      var filtros = "?_limit=600";

      if (this.retornaSite() == "7live") {
        filtros = "?dsaC3d889g9fd=iuiuy78d7g";
      }

      //* Carrega a lista de eventos
      const response = await api.get("/evento" + filtros);
      api.valid(response.data, this.$router);

      //* Define os eventos do usuario
      response.data.itensUsuario.filter(function (item) {
        if (!componentThis.itensUsuario[item.evento]) {
          componentThis.itensUsuario[item.evento] = item;
        }

        return true;
      });

      if (response.data.gmt) {
        this.$refs.listEventosHomeLive.gmt = response.data.gmt;
        this.$refs.listEventosHomeEncerrados.gmt = response.data.gmt;
      }

      this.itens = response.data.itens;

      this.$refs.listEventosHomeLive.loadGif = false;
      this.$refs.listEventosHomeEncerrados.loadGif = false;
    },
    async recarregarMeusDados() {
      if (this.$sessao && this.$sessao.usuario) {
        const response = await api.get("/usuario/meus-dados");

        this.planoAtivo = response.data.item.planoAtivo;
        this.planoDias = response.data.item.planoDias;
        this.vencimento = util.formatDate(response.data.item.vencimento);
        this.$refs.homeVencimento.carregando = false;
      }
    },
  },
  data: function () {
    return {
      planoAtivo: false,
      planoDias: -10,
      vencimento: "",
      isAdmin: false,
      itens: [],
      itensUsuario: {},
    };
  },
  async mounted() {
    var componentThis = this;

    this.isAdmin = false;

    if (this.$sessao && this.$sessao.usuario) {
      this.isAdmin = this.$sessao.usuario.tipoUsuario == "Administrador";
    }

    await componentThis.recarregarMeusDados();
    componentThis.carregarItens();

    setInterval(function () {
      componentThis.carregarItens();
    }, 20000);
  },
};
</script>

<style>
.tituloJogos {
  margin-top: 15px;
}
</style>